// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('product.importfileslist.articleimport',{
        url: '/articleimport',
        views: {'wideColumnView@product': {
            templateUrl: 'main/product/articleimport/articleimport.tpl.html',
            controller: 'ArticleImportController as vm'
        }},
        resolve: {
            companies: companiesResolver,
            collections: collectionsResolver,
            locations: locationsResolver
        }
    });
}

// @ngInject
function companiesResolver(FileDataImportApiService) {
    return FileDataImportApiService.getSuppliers();
}

// @ngInject
function collectionsResolver(FileDataImportApiService) {
    return FileDataImportApiService.getArticleCollections();
}

// @ngInject
function locationsResolver(FileDataImportApiService) {
    return FileDataImportApiService.getLocations();
}

// @ngInject
function ArticleImportController($state, $scope, $translate, companies, collections, locations, loadSpinnerService, FileDataImportApiService, ToasterService) {
    var vm = this;

    vm.companies = _.sortBy(companies, function(company) { return company.companyName; });
    vm.collections = collections;
    vm.locations = locations;

    vm.JSonAdaptedSheetData = {};
    vm.inDataColumnNames = [];

    vm.articlesOrdersImportRequest = {
        fileName: "",
        company: "",
        articlesOrdersImportRows: []
    };

    vm.selectedCollection = _.find(vm.collections, function(collection) {
        return collection.isCurrent;
    });
    vm.plannedDeliveryDate = new Date();

    vm.mapping = {
        alternativeArticleNumber: "",
        articleName: "",
        articleDescription: "",
        variant1Name: "",
        variant2Name: "",
        quantity: "",
        purchaseCost: "",
        previousPrice: "",
        salesPrice: "",
        itemGroupString: "",
        subCategory: "",
        articleTypeString: "",
        barcode: "",
        plannedDeliveryDate: "",
        orderNumberExternal: "",
        intrastatCode: "",
        departmentCode: ""
    };

    vm.articlesOrdersImport = {}; // The returned import data from backend.

    vm.handleFile = handleFile;
    vm.sendRequestData = sendRequestData;
    vm.saveMapping = saveMapping;
    vm.hasError = hasError;

    var fileInputDomElement = $("#xlf")[ 0 ];

    activate();

    function activate() {
        fileInputDomElement.addEventListener('change', handleFile, false);

        $scope.$watch(function() { return vm.articlesOrdersImportRequest.company; },
            function(company) {
                if (company === undefined || company === "") {
                    return;
                }

                FileDataImportApiService.getArticlesOrdersImportColumnMapping(company.id).then(function(response) {
                    if (response.id !== 0) { // Mapping exists.
                        var keys = Object.keys(response);
                        _.forEach(keys, function(key) {
                            if (_.find(vm.inDataColumnNames, function(columnName) { return columnName === response[key]; })) {
                                vm.mapping[key] = response[key];
                            }
                        });
                    }
                }, function (error) {
                    console.log(error);
                });

                console.log("Company changed.");
                console.log(company);
            }
        );
    }

    function hasError() {
        var hasNoCollectionCode = !vm.selectedCollection || !vm.selectedCollection.id;
        var hasNoBarcodeMapping = !vm.mapping || vm.mapping.barcode === '';
        //var hasNoLocation = !vm.articlesOrdersImportRequest.location || !vm.articlesOrdersImportRequest.location.id;
        var hasNoCompany = !vm.articlesOrdersImportRequest.company || !vm.articlesOrdersImportRequest.company.id;
        return hasNoCollectionCode || hasNoBarcodeMapping || hasNoCompany; //|| hasNoLocation
    }

    function handleFile(e) {
        var files = e.target.files;
        var i,f;
        for (i = 0, f = files[i]; i !== files.length; ++i) {
            var reader = new FileReader();

            reader.onload = onLoadFunction;
            loadSpinnerService.start('mainSpinner');
            reader.readAsArrayBuffer(f);
        }

        function onLoadFunction(e) {
            try {
                // --- File data read ---
                // From MDN: "readAsBinaryString is deprecated and readAsArrayBuffer() should be used instead."

                // ReadAsArrayBuffer solution.
                var data = "";
                var bytes = new Uint8Array(e.target.result);
                var length = bytes.byteLength;
                for (var i = 0; i < length; i++) {
                    data += String.fromCharCode(bytes[i]);
                }

                // --- XLSX ---
                // Read Excel data into a workbook object representation.
                var workbook = XLSX.read(data, {type: 'binary'});

                // Getting the name of the first sheet in the workbook.
                var firstSheetName = workbook.SheetNames[0];

                // Getting the sheet based on the firstSheetName.
                var workSheet = workbook.Sheets[firstSheetName];

                // The JSon representation of the worksheet returned by js-xlsx is pretty similar to how
                // we want our request data to be formatted.
                vm.JSonAdaptedSheetData = XLSX.utils.sheet_to_json(workSheet);

                extractInDataColumnNames();
            } catch (error) {
                console.log(error);
            } finally {
                loadSpinnerService.stop('mainSpinner');
            }
        }
    }

    // Once the mapping has been determined we can use it to create the DTOs we're going
    // to send to the backend.
    function createRequestData() {
        vm.articlesOrdersImportRequest.articlesOrdersImportRows = [];

        var mappingKeys = Object.keys(vm.mapping);

        _.forEach(vm.JSonAdaptedSheetData, function(rowObject) {
            var requestDto = {};
            _.forEach(mappingKeys, function(mapKey) {
                var mapValue = vm.mapping[mapKey];
                if (mapValue !== "" || mapValue !== undefined) {
                    requestDto[mapKey] = rowObject[mapValue];
                    requestDto['collection'] = vm.selectedCollection.collectionCode;
                    requestDto['plannedDeliveryDate'] = vm.plannedDeliveryDate;
                }
            });

            vm.articlesOrdersImportRequest.articlesOrdersImportRows.push(requestDto);
        });

        vm.articlesOrdersImportRequest.fileName = fileInputDomElement.value;
    }

    function saveMapping() {
        var mappingRequest = {
            alternativeArticleNumber: vm.mapping.alternativeArticleNumber,
            articleDescription: vm.mapping.articleDescription,
            articleName: vm.mapping.articleName,
            articleTypeString: vm.mapping.articleTypeString,
            barcode: vm.mapping.barcode,
            departmentCode: vm.mapping.departmentCode,
            intrastatCode: vm.mapping.intrastatCode,
            itemGroupString: vm.mapping.itemGroupString,
            orderNumberExternal: vm.mapping.orderNumberExternal,
            plannedDeliveryDate: vm.mapping.plannedDeliveryDate,
            previousPrice: vm.mapping.previousPrice,
            purchaseCost: vm.mapping.purchaseCost,
            quantity: vm.mapping.quantity,
            salesPrice: vm.mapping.salesPrice,
            subCategory: vm.mapping.subCategory,
            variant1Name: vm.mapping.variant1Name,
            variant2Name: vm.mapping.variant2Name
        };

        FileDataImportApiService.setArticlesOrdersImportColumnMapping(vm.articlesOrdersImportRequest.company.id, mappingRequest);
    }

    // Post the assembled data to backend.
    function sendRequestData() {
        saveMapping();
        loadSpinnerService.start('mainSpinner');
        createRequestData();

        FileDataImportApiService.createArticlesOrders(vm.articlesOrdersImportRequest).then(function(response) {
            vm.articlesOrdersImport = response;
            $state.go('product.importfileslist.importeditor', { importFileId: vm.articlesOrdersImport.id });
        }, function(error) {
            console.log(error);
            showErrorToaster(error.message);
        }).finally(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    // js-xlsx has done most of the work already. All we need to do is extract the javascript object
    // property names, and we're set.
    function extractInDataColumnNames() {
        if (vm.JSonAdaptedSheetData.length !== 0) {
            vm.inDataColumnNames = [];
            vm.inDataColumnNames.push("");
            _.forEach(vm.JSonAdaptedSheetData, function(sheetData) {
                var keys = Object.keys(sheetData);

                _.forEach(keys, function(key) {
                    if (!_.find(vm.inDataColumnNames, function(name) { return name === key; })) {
                        vm.inDataColumnNames.push(key);
                    }
                });
            });
        }
    }

    function showErrorToaster(message) {
        var title = $translate.instant('common.error');
        ToasterService.showError(message, title);
    }

}

angular
    .module('importfileslist.articleimport', [])
    .config(stateConfig)
    .controller('ArticleImportController', ArticleImportController);
